<style lang="sass" scoped>
</style>

<template>
    <div>
        <div class="main-button-bar">
            <el-button
                class="add-button"
                type="success"
                plain
                icon="el-icon-plus"
                size="small"
                title="新增"
                @click="add"
            ></el-button>
        </div>

        <el-table
            :data="suppliers"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 52"
            class="factory-supplier-table"
        >
            <el-table-column prop="name" label="名称" width="150"></el-table-column>
            <el-table-column prop="address" label="地址" width="300"></el-table-column>
            <el-table-column prop="status" label="状态" width="80">
                <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.status == 'Y'" type="success">有效</el-tag>
                    <el-tag size="small" v-if="scope.row.status == 'N'" type="warning">无效</el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="contacts" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="联系人电话" width="150"></el-table-column>

            <el-table-column prop="creatorName" label="创建人" width="100"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180">
                <template slot-scope="order">{{ $tools.timestampToTime(order.row.createTime)}}</template>
            </el-table-column>

            <el-table-column label="操作" width="180">
                <template slot-scope="supplier">
                    <el-button type="text" size="small" @click="edit(supplier.row.id)">修改</el-button>

                    <el-button
                        type="text"
                        v-if="supplier.row.status == 'Y'"
                        size="small"
                        @click="upstatus(supplier.row.id, 'N')"
                    >禁用</el-button>

                    <el-button
                        type="text"
                        v-if="supplier.row.status == 'Y'"
                        size="small"
                        @click="auth(supplier.row.id, supplier.row.authUser)"
                    >授权</el-button>

                    <el-button
                        type="text"
                        v-if="supplier.row.status != 'Y'"
                        size="small"
                        @click="upstatus(supplier.row.id, 'Y')"
                    >启用</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
            :title="supplierId ? '编辑供应商' : '新建供应商' "
            width="400px"
            :visible.sync="showAdd"
            @closed="refeshRule"
            class="buyer-dialog"
        >
            <el-form ref="supplierForm" label-width="100px" :model="supplier" :rules="rules">
                <el-form-item label="供应商名称" prop="name">
                    <el-input v-model="supplier.name"></el-input>
                </el-form-item>

                <el-form-item label="供应商地址" prop="address">
                    <el-input v-model="supplier.address"></el-input>
                </el-form-item>

                <el-form-item label="联系人" prop="contacts">
                    <el-input v-model="supplier.contacts"></el-input>
                </el-form-item>

                <el-form-item label="联系人电话" prop="phone">
                    <el-input v-model="supplier.phone"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button
                    v-if="supplierId"
                    type="primary"
                    size="small"
                    class="op-button"
                    @click="preSave()"
                >修改</el-button>
                <el-button
                    v-if="!supplierId"
                    type="primary"
                    size="small"
                    class="op-button"
                    @click="preSave()"
                >新增</el-button>
            </div>
        </el-dialog>

        <el-dialog title="授权用户" :visible.sync="showAuth" width="300px">
            <el-select multiple v-model="authUsers" clearable placeholder="选择用户">
                <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="doAuth">保存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data() {
        return {
            suppliers: null,
            showAdd: false,
            supplierId: null,
            supplier: {},
            showAuth: false,
            authUsers: [],
            users: [],
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入供应商名称",
                        trigger: "blur",
                    },
                    {
                        min: 2,
                        max: 128,
                        message: "长度在 2 到 128 个字符",
                        trigger: "blur",
                    },
                ],

                address: [
                    {
                        min: 0,
                        max: 256,
                        message: "长度在 2 到 128 个字符",
                        trigger: "blur",
                    },
                ],
                contacts: [
                    {
                        min: 0,
                        max: 64,
                        message: "长度在 2 到 128 个字符",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        min: 0,
                        max: 64,
                        message: "长度在 2 到 128 个字符",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        page() {
            let _this = this;

            _this.$http.post(
                ["factory/supplier/all"],
                [
                    function (data) {
                        _this.suppliers = data;
                    },
                ],
                ".alibaba-buyer-table"
            );
        },
        add() {
            this.supplierId = null;
            this.showAdd = true;
        },
        edit(id) {
            let _this = this;

            _this.supplierId = id;

            _this.$http.post(
                ["factory/supplier/get", { id: id }],
                [
                    function (data) {
                        _this.supplier = data;
                        _this.showAdd = true;
                    },
                ],
                ".alibaba-buyer-table"
            );
        },
        upstatus(id, status) {
            this.supplier = {
                id: id,
                status: status,
            };
            this.doSave();
        },
        preSave() {
            let _this = this;

            _this.$refs["supplierForm"].validate().then(function () {
                _this.doSave();
            });
        },
        doSave() {
            let _this = this;

            _this.$http.post(
                ["factory/supplier/save", _this.supplier],
                [
                    function (data) {
                        _this.showAdd = false;
                        _this.page();
                    },
                ],
                ".alibaba-buyer-table"
            );
        },
        refeshRule() {
            this.$refs["supplierForm"].resetFields();
        },
        auth(id, users) {
            let _this = this;

            _this.$http.post(
                ["user/listFactory"],
                [
                    function (data) {
                        _this.users = data;

                        if (users) {
                            _this.authUsers = [];

                            users.split(",").forEach((data) => {
                                _this.authUsers.push(window.parseInt(data));
                            });
                        } else {
                            _this.authUsers = [];
                        }

                        _this.supplierId = id;
                        _this.showAuth = true;
                    },
                ],
                ".taobao-stop-table"
            );
        },

        doAuth() {
            let _this = this;

            _this.$http.post(
                ["factory/supplier/save", {id: _this.supplierId, authUser: _this.authUsers.join(",")}],
                [
                    function () {
                        _this.showAuth = false;
                        _this.supplierId = null;
                        _this.page();
                    },
                ],
                ".op-button"
            );
        },
    },
    mounted() {
        this.page();
    },
};
</script>